export const providerTypes = {
  Undefined: '0',
  User: '1',
  Office: '2',
  Municipality: '3',
  Organization: '4'
};

export const mappedProviderTypes = Object.entries(providerTypes)
  .map(([key]) => ({ value: key, label: key }));